import axios from "axios";

const state = {
  axiosResult: null,
  axiosFileResult: null,
  axiosMaintainFileResult: null,
  axiosMaintainStatusFileResult: null,
  axiosDeviceFileResult: null,
};
const getters = {
  get_axiosResult: (state) => {
    return state.axiosResult;
  },
  get_axiosFileResult: (state) => {
    return state.axiosFileResult;
  },
  get_axiosMaintainFileResult: (state) => {
    return state.axiosMaintainFileResult;
  },
  get_axiosMaintainStatusFileResult: (state) => {
    return state.axiosMaintainStatusFileResult;
  },
  get_axiosDeviceFileResult: (state) => {
    return state.axiosDeviceFileResult;
  },
};
const actions = {
  async axiosAction(context, params) {
    await axios
      .post("/static/php/modules.php", params)
      .then(
        function (response) {
          console.log(response);
          const result = response.data;
          context.commit("AXIOSACTION", result);
        }.bind(this)
      )
      .catch(function (err) {
        console.log(err);
      });
  },
  async axiosActionFile(context, formData) {
    await axios
      .post("/static/php/uploadImage.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(
        function (response) {
          console.log(response);
          const result = response.data;
          context.commit("AXIOSACTIONFILE", result);
        }.bind(this)
      )
      .catch(function (err) {
        console.log(err);
      });
  },
  async axiosActionMaintainFile(context, formData) {
    // 編輯保養計畫
    await axios
      .post("/static/php/uploadMaintain.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(
        function (response) {
          console.log(response);
          const result = response.data;
          context.commit("AXIOSMAINTAINFILERESULT", result);
        }.bind(this)
      )
      .catch(function (err) {
        console.log(err);
      });
  },
  async axiosActionMaintainStatusFile(context, formData) {
    // 維修說明填寫
    await axios
      .post("/static/php/uploadMaintainStatus.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(
        function (response) {
          console.log(response);
          const result = response.data;
          context.commit("AXIOSMAINTAINSTATUSFILERESULT", result);
        }.bind(this)
      )
      .catch(function (err) {
        console.log(err);
      });
  },
  async axiosActionDeviceFile(context, formData) {
    // 新增設備資料
    await axios
      .post("/static/php/uploadDeviceFile.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(
        function (response) {
          console.log(response);
          const result = response.data;
          context.commit("AXIOSACTIONDEVICEFILE", result);
        }.bind(this)
      )
      .catch(function (err) {
        console.log(err);
      });
  },
};
const mutations = {
  AXIOSACTION(state, result) {
    state.axiosResult = result;
  },
  AXIOSACTIONFILE(state, result) {
    state.axiosFileResult = result;
  },
  AXIOSMAINTAINFILERESULT(state, result) {
    state.axiosMaintainFileResult = result;
  },
  AXIOSMAINTAINSTATUSFILERESULT(state, result) {
    state.axiosMaintainStatusFileResult = result;
  },
  AXIOSACTIONDEVICEFILE(state, result) {
    state.axiosDeviceFileResult = result;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
